<template>
  <div
    v-if="alert.visible"
    class="flex flex-col w-full gap-2 bg-white rounded-lg"
  >
    <div
      role="alert"
      :class="{
        'relative flex w-full px-4 py-4 text-base  bg-opacity-20 rounded-lg font-regular': true,
        'bg-green-900 text-green-900': alert.type === 'success',
        'bg-red-900 text-red-900': alert.type === 'failure',
      }"
      data-dismissible="alert"
    >
      <div class="mr-12 text-sm py-2">
        <span class="flex gap-2 items-center"
          ><i class="fa-solid fa-circle-info text-[20px]"></i>
          {{ alert.message }}
        </span>
      </div>
      <button
        @click="handleCloseAlert"
        data-dismissible-target="alert"
        class="!absolute top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-main900 transition-all hover:bg-white/30 active:bg-white/40 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
      >
        <span
          class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          ><i class="fa-solid fa-xmark text-[18px]"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NotificationAlert",
  computed: {
    ...mapGetters(["alert"]),
  },
  methods: {
    ...mapActions(["closeAlert", "showAlert"]),
    handleCloseAlert() {
      this.closeAlert();
      this.$emit("close");
    },
  },
  mounted() {
    // this.showAlert({ type: "failure", message: "Welcome to the dashboard!" });
  },
};
</script>
